import { Form } from 'react-bootstrap';

const SelectOption = ({ handleChange, options, selectedValue, size, disabled, className, style }) => {
  const selectedIndex = selectedValue === null ? 0 : selectedValue;
  return (
    <>
      <Form.Select disabled={disabled}  value={selectedIndex} 
      size={size} className={className} onChange={handleChange}
      style={style}
      >
        {options && options.map((o) => <option key={o.value} value={o.value}>{o.text}</option>)}
      </Form.Select>
    </>
  );
}

export default SelectOption;
